import React, { Dispatch, SetStateAction, FC, useEffect, useState } from 'react';

import useGetTags from '../../hooks/tags/useGetTags';
import useReorderTags from '../../hooks/tags/useReorderTags';

import { SVGIcon } from '../wrappers/SVGIcon';

import { Icons } from '../../data/Assets';

interface IDeleteModalProps {
    isTagsModalOpen: boolean;
    setIsTagsModalOpen: Dispatch<SetStateAction<boolean>>;
};

interface ITag {
    id: number;
    name: string;
    order: number;
};

const TagsModal: FC<IDeleteModalProps> = ({
    isTagsModalOpen,
    setIsTagsModalOpen,
}) => {

    const [enabled, setEnabled] = useState<boolean>(false);
    const [tags, setTags] = useState<ITag[]>([]);
    const [recentModifiedTag, setRecentModifiedTag] = useState<ITag | null>(null);

    const { data: tagsData } = useGetTags(enabled);
    const { mutate: reorderTag } = useReorderTags();

    useEffect(() => {
        if (isTagsModalOpen) {
            setEnabled(true);
        };
    }, [isTagsModalOpen]);

    useEffect(() => {
        if (tagsData) {
            setTags(tagsData.data);
        };
    }, [tagsData]);

    const onCloseModal = () => {
        setEnabled(false);
        setTags([]);

        setIsTagsModalOpen(false);
    };

    const onReorderTag = (tag: ITag, action: 'up' | 'down') => {
        setRecentModifiedTag(tag);
        reorderTag({ tagId: tag.id, action });
    };

    useEffect(() => {
        if (recentModifiedTag) {
            const timeout = setTimeout(() => {
                setRecentModifiedTag(null);
            }, 5000);

            return () => clearTimeout(timeout);
        };
    }, [recentModifiedTag]);

    return (
        <div className='imm_admin__tags_modal'>
            <div className='imm_admin__tags_modal__container'>
                <div className='imm_admin__tags_modal__header'>
                    <h4>Manage Tags</h4>
                    <button onClick={onCloseModal}><SVGIcon src={Icons.X} /></button>
                </div>
                <div className='imm_admin__tags_modal__body'>
                    <div className="imm_admin__tags_modal__tags">

                        {tags?.length
                            ? tags.map((tag: ITag, idx: number) =>
                                <div
                                    key={tag.id}
                                    className={`imm_admin__tags_modal__tag ${recentModifiedTag?.id === tag.id ? 'imm_admin__tags_modal__tag__recent' : ''}`}
                                >
                                    <span>{tag.name}</span>
                                    <div className='imm_admin__tags_modal__tag__action'>
                                        <button
                                            onClick={() => onReorderTag(tag, 'up')}
                                            disabled={idx === 0}
                                        >
                                            <SVGIcon src={Icons.ArrowShort} rotation={180} />
                                        </button>
                                        <button
                                            onClick={() => onReorderTag(tag, 'down')}
                                            disabled={idx === tags.length - 1}
                                        >
                                            <SVGIcon src={Icons.ArrowShort} />
                                        </button>
                                    </div>
                                </div>
                            )
                            : <div className="imm_admin__tags_modal__tag">
                                No tags found!
                            </div>
                        }
                    </div>
                </div>
                <div className='imm_admin__tags_modal__footer'>
                    <button className='modal__decline_btn' onClick={onCloseModal}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TagsModal;